import { post, get } from "../helpers/apiHelper";

async function searchUserReport(params) {
    return await post(`reports/userReports`, params);
}

async function getUserReportDetails(params) {
    const {userId, detailType} = params;
    return await get(`reports/userReports/${userId}/${detailType}`);
}

export default {
    searchUserReport,
    getUserReportDetails
}